/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nfts.vue?vue&type=template&id=7fe31310&scoped=true"
import script from "./nfts.vue?vue&type=script&lang=js"
export * from "./nfts.vue?vue&type=script&lang=js"
import style0 from "./nfts.vue?vue&type=style&index=0&id=7fe31310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe31310",
  null
  
)

export default component.exports